Ext.define('SA.view.legend.LegendHeader', {
    alias: 'widget.legend-header',
    extend: 'Ext.Component',

    childEls: ['title'],
    cls: 'sa-legend-header',

    getTargetEl() {
        return this.title;
    },

    renderTpl: [
        '<div id="{id}-title" class="sa-legend-header-title">Legend</div>',
        '<a class="sa-legend-header-button">',
            '<div class="sa-legend-burger-button-bar"></div>',
            '<div class="sa-legend-burger-button-bar"></div>',
            '<div class="sa-legend-burger-button-bar"></div>',
        '</a>'
    ]
});